import { Clickable, Col, Icon, Row, Sidepanel, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { openMobileAppLink } from '../../core';

const Phone = styled.div`
  ${(props) => `
  position: absolute;
  height: ${props.ht};
  width: ${props.wid};
  background-repeat: round;
  background-image: url(${props.image});
  z-index: ${props.zIndex};
  top: ${props.top};
  left: ${props.left};
  right: ${props.right};
  bottom: ${props.bottom};
`}
`;

const GetTheApp = ({ alwaysShow }) => {
  const { showGetApp, isMobile } = useSelector((state) => state.appState),
    dispatch = useDispatch(),
    { t } = useTranslation();

  function close() {
    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        showGetApp: false
      }
    });
  }

  return (
    <Sidepanel
      zIndex={alwaysShow ? 1 : 5}
      visible={alwaysShow || showGetApp}
      fullScreen
      bg="#F3F5F8"
    >
      <Row wid="938px" pos="relative" ht={`calc(100vh - ${isMobile ? '57px' : '73px'})`}>
        {!alwaysShow && (
          <Row
            noFlex
            pos="absolute"
            top="10px"
            right={isMobile ? '16px' : '0'}
            zIndex={4}
            className="EHEHE"
          >
            <Clickable onClick={close}>
              <Icon type="close" />
            </Clickable>
          </Row>
        )}

        <Phone
          image={require('assets/branding/phone-1.png')}
          wid={isMobile ? '136px' : '272px'}
          ht={isMobile ? '273px' : '546px'}
          zIndex={3}
          top={isMobile ? '340px' : '57px'}
          left={isMobile ? 'unset' : '184px'}
          bottom={isMobile ? '-345px' : 'unset'}
          right={isMobile ? '100px' : 'unset'}
        />

        <Phone
          image={require('assets/branding/phone-2.png')}
          wid={isMobile ? '120px' : '240px'}
          ht={isMobile ? '242px' : '484px'}
          zIndex={2}
          top={isMobile ? '355px' : '88px'}
          left={isMobile ? 'unset' : '0'}
          bottom={isMobile ? '-330px' : 'unset'}
          right={isMobile ? '50px' : 'unset'}
        />

        <Col
          pos="absolute"
          top={isMobile ? '-90px' : '-20px'}
          left={isMobile ? '-170px' : '300px'}
          wid="641px"
          ht="700px"
          bg={theme.SECONDARY}
          hasRadius="700px"
          centerAll
          pad="0 0 0 59px"
        >
          <Col wid="376px" noFlex center>
            <Text h1 col="#fff">
              {t('getTheApp.header')}
            </Text>

            <Text b1 col="#fff" marg="16px 0 0">
              {t('getTheApp.setupAccount')}
            </Text>
          </Col>

          {isMobile ? (
            <Col noFlex gap="12px" center marg="40px 0 0" wid="376px">
              <Clickable
                onClick={() => {
                  openMobileAppLink(false);
                }}
              >
                <img src={require('assets/images/app-store.png')} alt="" />
              </Clickable>

              <Clickable
                onClick={() => {
                  openMobileAppLink(true);
                }}
              >
                <img src={require('assets/images/google-play.png')} alt="" />
              </Clickable>
            </Col>
          ) : (
            <Row gap="12px" marg="40px 0 0" start wid="376px">
              <Clickable
                onClick={() => {
                  openMobileAppLink(false);
                }}
              >
                <img src={require('assets/images/app-store.png')} alt="" />
              </Clickable>

              <Clickable
                onClick={() => {
                  openMobileAppLink(true);
                }}
              >
                <img src={require('assets/images/google-play.png')} alt="" />
              </Clickable>
            </Row>
          )}
        </Col>
      </Row>
    </Sidepanel>
  );
};

export default GetTheApp;
